<template>
  <div class="box-color">
    <div class="login-index">
        <div style="margin: auto">
            <v-alert type="success">
                {{$t('login.authSuccess')}}
            </v-alert>
            <p style="text-align: center;color: #adadad;font-size: 12px;margin-bottom: 20px;">{{$t('login.canClose')}}</p>
            <p style="display: flex;align-items: center;">
                <v-icon size="16" style="margin-right:8px;color: red;">{{svgPathSmile}}</v-icon>
                <span style="font-size:14px;">{{$t('login.clickDown')}}</span>
            </p>
        </div>
    </div>
  </div>
</template>

<script>
import { mdiEmoticonWinkOutline } from '@mdi/js';

export default {
    data() {
        return{
            svgPathSmile: mdiEmoticonWinkOutline,
        }
    }
}
</script>
<style lang='scss' scoped>
  .box-color {
    height: 100vh;
    width: 100%;
    background-color: #FFFFFF;
  }
    .login-index {
        // background: linear-gradient(143deg, #2E6BF7, #2EB7F7);
        display: flex;
        position: relative;
        top: 50px;
    }
</style>
